import { Component, OnInit } from '@angular/core';
import { IBillingDocument, coverService } from '@dch/billing-business-logic';
import {
  UtilsService,
  getDeferralCardVariant,
} from '../services/utils.service';
import { Router } from '@angular/router';
import {
  OVERVIEW_PAGE,
  DEFERRAL_ACCEPT_NEW_DATE,
} from '../config/my-bill.constants';
import { format, addDays } from 'date-fns';
import { TranslationService } from '@dch/ng-common';
import { INewDueDates } from '../models/deferral.model';

@Component({
  selector: 'my-bill-deferral-select-date-page',
  templateUrl: './deferral-select-date-page.component.html',
  standalone: false,
})
export class DeferralSelectDatePageComponent implements OnInit {
  constructor(
    private utilsService: UtilsService,
    private router: Router,
    private translationService: TranslationService
  ) {}

  billDocument?: IBillingDocument;
  newDueDates: INewDueDates[] = [];
  selectedNewPaymentDate?: string;
  DEFERRAL_ACCEPT_NEW_DATE = DEFERRAL_ACCEPT_NEW_DATE;

  ngOnInit() {
    const deferralRequiredInfo =
      this.utilsService.getDeferralDocumentInfoFromStorage();
    if (
      deferralRequiredInfo &&
      deferralRequiredInfo.billDocument &&
      getDeferralCardVariant(
        deferralRequiredInfo.customerPaymentProfile,
        deferralRequiredInfo.billDocument.partialDeferralCheck
      ) === '1'
    ) {
      this.billDocument = deferralRequiredInfo.billDocument;
      this.initializeDates(deferralRequiredInfo.billDocument);
    } else {
      this.router.navigate([OVERVIEW_PAGE]);
    }
  }

  initializeDates(billDocument: IBillingDocument) {
    this.newDueDates.push(this.addDaysToDueDate(5, billDocument));
    this.newDueDates.push(this.addDaysToDueDate(10, billDocument));
    this.newDueDates.push(this.addDaysToDueDate(15, billDocument));
  }

  private addDaysToDueDate(
    amountOfDays,
    billDocument: IBillingDocument
  ): INewDueDates {
    const [day, month, year] = billDocument.dueDate.split('/');
    const newDate = addDays(
      new Date(Number(year), Number(month) - 1, Number(day)),
      amountOfDays
    );
    const newDay = Number(format(newDate, 'DD'));
    const newMonthNumber = Number(format(newDate, 'MM')) - 1;
    const newMonth = coverService.getMonthTranslationsByMonthNumber(
      newMonthNumber,
      (key: string) => this.translationService.getTranslatedValueFor(key)
    );
    const newYear = format(newDate, 'YYYY');
    return {
      stringFormatted: `${newDay} ${newMonth} ${newYear}`,
      newDue: newDate,
    };
  }

  onDateChange(date) {
    this.selectedNewPaymentDate = date;
  }
}
